import React from "react";
import Layout from "./src/components/layout";
import PageTransition from "./src/components/PageTransition";

import "@fontsource/cormorant-garamond/500.css";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/200.css";

export const wrapPageElement = ({ element, props }) => {
  return (
    <Layout {...props}>
      <PageTransition location={props.location}>
        {element}
      </PageTransition>
    </Layout>
  );
};
